export const authFreePaths = new Set(['/']);
